import React, { ReactElement } from "react";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import enumStrings from "../../../enumStrings";
import ErrorBasePage, { ErrorPagePlacement } from "./ErrorBasePage";

const Error500 = ({
  placement = "dashboard",
}: {
  placement?: ErrorPagePlacement;
}): ReactElement => {
  return (
    <ErrorBasePage
      eyebrow={`Error ${enumStrings.pages.error500.title}`}
      subtitle={enumStrings.pages.error500.subtitle}
      description={enumStrings.pages.error500.description}
      emailSubject={enumStrings.pages.error500.emailSubject}
      icon={<WarningAmberRoundedIcon />}
      tone="red"
      placement={placement}
      isAlert
      wide
    />
  );
};

export default Error500;
